import React, { useState, useEffect } from "react";
import RangeSlider from "./RangeSlider";
import {  useSelector } from "react-redux";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

const ResultsPageHeader = ({ onSalaryChange, onYearChange, summmary }) => {
  const { yearRange, salaryRange } = useSelector((state) => state.data);
  const [filtersOpen, setFiltersOpen] = useState(false);

  const [range, setRange] = useState(salaryRange);
  const [years, setYears] = useState(yearRange);

  useEffect(() => {
    if (salaryRange) {
      setRange(salaryRange);
    }
  }, [salaryRange]);

  useEffect(() => {
    if (yearRange) {
      setYears(yearRange);
    }
  }, [yearRange]);

  const handleSalaryRangeChange = (value) => {
    setRange(value);
    onSalaryChange(value);
  };

  const handleYearRangeChange = (value) => {
    setYears(value);
    onYearChange(value);
  };

  return (
  <div className="bg-surface-muted shadow-md">
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">

      {/* Filters panel */}
      <div className="bg-surface-soft sm:border-r md:border-r-0 lg:border-r border-border md:border-b md:border-border lg:border-b-0">

        {/* Mobile-only toggle header */}
        <div className="sm:hidden w-full flex items-center justify-between px-4 py-3 font-semibold text-text-primary">
          <span>Filters</span>
          <button
            type="button"
            onClick={() => setFiltersOpen((v) => !v)}
            className={`p-1 rounded transition-colors text-gray-600`}
            aria-expanded={filtersOpen}
            aria-controls="filters-content"
            aria-label="Toggle filters"
          >
            <ChevronDownIcon
              className={`h-5 w-5 transition-transform ${
                filtersOpen ? "rotate-180" : "rotate-0"
              }`}
            />
          </button>
        </div>
          {/* Content: hidden on mobile when collapsed, always visible on sm+ */}
          <div
            id="filters-content"
            className={`${filtersOpen ? "block" : "hidden"} sm:block`}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2">
              {/* Salary */}
              <div className="sm:border-r border-border-strong px-3 py-2">
                <label
                  htmlFor="salary-slider"
                  className="text-sm font-semibold mb-2 text-center block"
                >
                  Starting Salary Per Annum
                </label>

                <div className="grid grid-cols-[50px_1fr_60px] items-center gap-3">
                  <span className="text-sm text-right" aria-live="polite">
                    ${range[0]}k
                  </span>

                  <RangeSlider
                    id="salary-slider"
                    value={range}
                    onValueChange={handleSalaryRangeChange}
                    min={salaryRange[0]}
                    max={salaryRange[1]}
                    step={10}
                    name="SALARY"
                    className="w-full"
                    aria-label="Starting Salary Range: $0k to $0k"
                  />

                  <span className="text-sm text-left" aria-live="polite">
                    ${range[1]}k
                  </span>
                </div>
              </div>

              {/* Years */}
              <div className="px-3 py-2">
                <label
                  htmlFor="years-slider"
                  className="text-sm font-semibold mb-2 text-center block"
                >
                  Years of Study
                </label>

                <div className="grid grid-cols-[50px_1fr_60px] items-center gap-3">
                  <span className="text-sm text-right" aria-live="polite">
                    {years[0]} yr
                  </span>

                  <RangeSlider
                    id="years-slider"
                    value={years}
                    onValueChange={handleYearRangeChange}
                    min={yearRange[0]}
                    max={yearRange[1]}
                    step={1}
                    name="STUDY"
                    className="w-full"
                    aria-label="Years of Study Range: 0 to 0 years"
                  />

                  <span className="text-sm text-left" aria-live="polite">
                    {years[1]} yr
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className="flex items-center px-3 py-3 sm:py-0">
          <p className="text-sm font-semibold text-center text-text-strong leading-relaxed">
            {summmary}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResultsPageHeader;
